import CustomerIndex from "@/components/billing/customers/CustomerIndex.vue";
import CustomerAdd from "@/components/billing/customers/CustomerAdd.vue";
import CustomerDetail from "@/components/billing/customers/CustomerDetail.vue";
import CustomerEdit from "@/components/billing/customers/CustomerEdit.vue";

let routesCustomerAccess= [
    {
        path: '',
        meta: {
          title: "List Customer",
        },
        name: "CustomerIndex",
        component: CustomerIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create Customer",
        },
        name: "CustomerAdd",
        component: CustomerAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail Customer",
        },
        name: "CustomerDetail",
        component: CustomerDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit Customer",
        },
        name: "CustomerEdit",
        component: CustomerEdit
    },
    
]

export default routesCustomerAccess
  